<div fxLayout="row" fxLayoutAlign="center center" *ngIf="leaders?.length == 3" class="content">
    <div fxLayout="column" fxLayoutAlign="end center" fxLayoutGap="5px" class="data" fxLayoutGap="5px">
        <app-podium-avatar
            fxLayout="column"
            fxLayoutAlign="center center"
            fxLayoutGap="10px"
            *ngIf="second()"
            [leader]="second()"
        ></app-podium-avatar>
    </div>

    <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="5px" class="data first-place" fxLayoutGap="5px">
        <app-podium-avatar
            fxLayout="column"
            fxLayoutAlign="center center"
            fxLayoutGap="10px"
            *ngIf="first()"
            [leader]="first()"
        ></app-podium-avatar>
    </div>

    <div fxLayout="column" fxLayoutAlign="end center" fxLayoutGap="5px" class="data" fxLayoutGap="15px">
        <app-podium-avatar
            fxLayout="column"
            fxLayoutAlign="center center"
            fxLayoutGap="10px"
            *ngIf="third()"
            [leader]="third()"
        ></app-podium-avatar>
    </div>
</div>

<div fxLayout="row" fxLayoutAlign="center  center" *ngIf="leaders?.length <= 2" class="content" fxLayoutGap="15px">
    <div class="data" *ngFor="let leader of leaders">
        <app-podium-avatar
            fxLayout="column"
            fxLayoutAlign="center center"
            fxLayoutGap="10px"
            [leader]="leader"
        ></app-podium-avatar>
    </div>
</div>
